import Glide from '@glidejs/glide'

export const ProductGallery = () => {
  const $carousels = document.querySelectorAll('.glide.glide-product-gallery')

  if (!$carousels.length > 0) return

  const ChangeImage = (mainImage, image, i, currentCarousel) => {
    const imgSrc = image.querySelector('img').getAttribute('src')
    mainImage.src = imgSrc

    currentCarousel.go(`=${i}`)
  }

  $carousels.forEach(($carousel) => {
    const mainImage = document.querySelector('.product-gallery .main-image img')
    const images = document.querySelectorAll('.product-gallery .image')

    const ProductGalleryCarousel = new Glide($carousel, {
      autoplay: 4000,
      dragThreshold: true,
      focusAt: 0,
      gap: 10,
      hoverpause: true,
      perView: 4,
      type: 'slider',
      breakpoints: {
        1023: {
          perView: 3
        },
        599: {
          perView: 2
        }
      }
    }).mount()

    images.forEach((image, i) => {
      image.addEventListener('click', (e) => {
        ChangeImage(mainImage, e.currentTarget, i, ProductGalleryCarousel)
      })
    })

    ProductGalleryCarousel.on('run', function() {
      ChangeImage(mainImage, images[ProductGalleryCarousel.index], ProductGalleryCarousel.index, ProductGalleryCarousel)
    })
  })
}
